import { IncludeType } from '../../../common';
import { ServiceType } from '../../enums';
import { FamilyGroup } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getGroupService = async (
  groupId: number,
  locale: string,
  serviceType: ServiceType,
  includeType: IncludeType = IncludeType.Available
): Promise<FamilyGroup> => {
  const url = `/group/${groupId}/service?include=${includeType}&marketLocale=${locale}&serviceType=${serviceType}`;
  const response = await productCatalogueHttp.get<FamilyGroup>(url);
  return response.data;
};
